module.exports = __webpack_public_path__ + "img/グループ 232.01c67725.png";